import { Box, styled } from '@mui/material';

const Wrapper = styled(Box)(({ theme }) => ({
  border: `1px solid ${theme.palette.common.black}`,
  overflow: 'hidden',
  borderRadius: '4px',
  width: 'min-content'
}));

const HeaderWrapper = styled(Box)(({ theme }) => ({
  width: '100%',
  padding: 16,
  borderBottom: `1px solid ${theme.palette.common.black}`,
  backgroundColor: theme.palette.grey[200],
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between'
}));

const CanvasWrapper = styled(Box)(() => ({
  borderRadius: '4px',
  cursor: 'grab',
  backgroundColor: '#c8c8c8'
}));

const Link = styled('a')(() => ({
  svg: {
    display: 'block'
  }
}));

export default { CanvasWrapper, HeaderWrapper, Link, Wrapper };
